module.exports = __webpack_public_path__ + "static/media/logo-black.08c81962.png";